<template>
  <transition
    name="banner-slide-up"
    appear
  >
    <q-card
      v-if="!isOnline"
      class="offline-toast flex items-center no-wrap md-radius q-py-sm q-pl-sm q-pr-md border-brand-light"
      role="status"
      aria-live="polite"
    >
      <span class="offline-toast__badge flex flex-center round bg-accent-light q-mr-sm">
        <lucide-icon
          name="wifi-off"
          size="20px"
          :stroke-width="2"
          color="brand-dark"
        />
      </span>

      <span class="column line-height-sm">
        <span class="text-16 text-brand-dark text-font-semibold">You're offline</span>
        <span class="q-mt-xxs text-12 text-info">
          Actions won't work until your connection returns.
        </span>
      </span>
    </q-card>
  </transition>
</template>

<script setup>
  import { useOnlineStatus } from 'src/composables/app/system/useOnlineStatus'

  const { isOnline } = useOnlineStatus()
</script>

<style lang="scss">
  .offline-toast {
    position: fixed;
    bottom: 1.5rem;
    left: 50%;
    transform: translateX(-50%);
    z-index: 300000; // above all modals, drawers, and the mobile block screen (200000)
    max-width: calc(100vw - 2rem);
    box-shadow: $main-shadow;

    &__badge {
      width: 2rem;
      height: 2rem;
      flex-shrink: 0;
      animation: pulse 2.4s ease-in-out infinite;
    }
  }
</style>
